import { createContext, useState, useEffect } from 'react';

export const BookingDataContext = createContext();

export function BookingDataProvider({ children }) {
    const [bookingData, setBookingData] = useState(() => {
        const saved = sessionStorage.getItem('bookingData');
        return saved ? JSON.parse(saved) : {};
    });

    useEffect(() => {
        if (bookingData) {
            sessionStorage.setItem('bookingData', JSON.stringify(bookingData));
        } else {
            sessionStorage.removeItem('bookingData'); // optional cleanup
        }
    }, [bookingData]);

    return (
        <BookingDataContext.Provider value={{ bookingData, setBookingData }}>{children}</BookingDataContext.Provider>
    );
}
